import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3.6 8.25a4.65 4.65 0 1 1 9.3 0 4.65 4.65 0 0 1-9.3 0ZM8.25 2.4a5.85 5.85 0 1 0 3.69 10.39l2.636 2.635.424.424.849-.849-.425-.424-2.635-2.635A5.85 5.85 0 0 0 8.25 2.4Z",
		clipRule: "evenodd"
	})
});
export default SvgSearch;
